import { commentsList } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-chat-3-line"></i>
            用户声音
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            用户热评
          </h2>
          <p className="text-sm text-foreground-500 mt-2">看看其他吃瓜群众怎么说</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {commentsList.map((comment, idx) => (
            <div
              key={idx}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-default"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-800 truncate">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}